export default {
	buttons: {
		auth: {
			login: "Entrar",
			create_account: "Criar conta",
		},
		general: {
			save: "Guardar",
			add: "Adicionar",
			edit: "Editar",
			delete: "Eliminar",
			grid: "Grelha",
			list: "Lista",
			devices: "Dispositivos",
			patients: "Pacientes",
			manage: "Gerir",
			history: "História",
			by_date: "Por data",
			actives: "Ativos",
			all: "Todos",
			upcoming: "Próximos",
			calendar: "Calendário",
			by_day: "Por dia",
			detach: "Desanexar",
			attach: "Anexar",
			submit: "Enviar",
			resume: "Resumo",
			response: "Resposta",
			configs: "Configurações",
		},
		actions: {
			get_more: "Obter mais",
			add_group: "Adicionar grupo",
			add_device: "Adicionar dispositivo",
			add_patient: "Adicionar paciente",
			edit_group: "Editar grupo",
			edit_device: "Editar dispositivo",
			edit_patient: "Editar paciente",
			view_all: "Ver tudo",
			view_watch: "Ver relógio",
			clear_alerts: "Limpar alertas",
			// user profile
			update_name: "Atualizar nome",
			update_email: "Atualizar email",
			update_password: "Atualizar senha",
			update_picture: "Atualizar imagem",
			// watch profile
			edit_profile: "Editar Perfil",
			add_contact: "Adicionar contato",
			add_disease: "Adicionar doença",
			add_relation: "Adicionar relação",
			add_number: "Adicionar número",
			add_insurance: "Adicionar seguro",
			// pillbox
			add_pill: "Adicionar medicamento",
			// appointments
			add_appointment: "Adicionar compromisso",
			// health reports
			add_healthreport: "Adicionar relatório",
			edit_healthreport: "Editar relatório",
			delete_healthreport: "Eliminar relatório",
			// medical documents
			add_medicaldocument: "Adicionar documento",
			edit_medicaldocument: "Editar documento",
			view_report: "Ver relatório",
			// readings
			add_parameters: "Adicionar parâmetros",
			edit_parameters: "Editar parâmetros",
			delete_parameters: "Eliminar parâmetros",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/buttons/buttons_pt.js